import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

const DonutChartComponent = (props) => {
  ChartJS.register(ArcElement, Tooltip, Legend);

  const { list } = props;

  let countData = [];
  let nameLabels = [];

  countData = list.map((item) => {
    return item.count;
  });

  nameLabels = list.map((item) => {
    return item.name;
  });

  const data = {
    labels: nameLabels,
    datasets: [
      {
        labels: nameLabels,
        data: countData,
        borderColor: [
          "#25287a",
          "#ed4613",
          "#63ddeb",
          "#e9abff",
          "#f7e672",
          "#3d9470",
          "#d43b48",
        ],
        backgroundColor: [
          "#25287a",
          "#ed4613",
          "#63ddeb",
          "#e9abff",
          "#f7e672",
          "#3d9470",
          "#d43b48",
        ],
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    animation: false,
    plugins: {
      title: {
        display: true,
      },

      legend: {
        display: true,
        position: "right",
        labels: {
          usePointStyle: true,
          padding: 30,
        },
      },

      datalabels: {
        align: "end",
        anchor: "end",
        display: true,
        color: "black",
        formatter: (value) => {
          return value;
        },
      },
    },

    radius: "70%",

    label: {
      display: false,
    },
  };

  return (
    <div style={{ width: "100%" }}>
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default DonutChartComponent;
